import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class MandatoryParamsCommand extends AbstractConfDataCommand {
  includeNextState: boolean;
}